import type { CSSProperties, ReactNode } from 'react';
import { cn } from '@/utils/cn';

// Minecraft-Farbcodes (§0-§f); Schwarz leicht aufgehellt, sonst unsichtbar auf dunklem Grund.
const COLORS: Record<string, string> = {
  '0': '#4a4a4a', '1': '#3b3bd6', '2': '#00AA00', '3': '#00AAAA', '4': '#d23a3a', '5': '#AA00AA',
  '6': '#FFAA00', '7': '#AAAAAA', '8': '#6b6b6b', '9': '#5555FF', a: '#55FF55', b: '#55FFFF',
  c: '#FF5555', d: '#FF55FF', e: '#FFFF55', f: '#FFFFFF',
};

/** MOTD so darstellen, wie ihn Spieler in der Serverliste sehen (§-Farben, fett, kursiv, Zeilen). */
export const MotdText = ({ text, className }: { text: string; className?: string }) => {
  const out: ReactNode[] = [];
  let style: CSSProperties = {};
  let buf = '';
  const flush = () => {
    if (buf) out.push(<span key={out.length} style={style}>{buf}</span>);
    buf = '';
  };

  for (let i = 0; i < text.length; i++) {
    const ch = text[i]!;
    if (ch === '§' && i + 1 < text.length) {
      flush();
      const code = text[++i]!.toLowerCase();
      if (COLORS[code]) style = { color: COLORS[code] };
      else if (code === 'l') style = { ...style, fontWeight: 700 };
      else if (code === 'o') style = { ...style, fontStyle: 'italic' };
      else if (code === 'n') style = { ...style, textDecoration: 'underline' };
      else if (code === 'm') style = { ...style, textDecoration: 'line-through' };
      else if (code === 'r') style = {};
      continue;
    }
    if (ch === '\n') {
      flush();
      out.push(<span key={out.length} className="text-fg-muted/50"> / </span>);
      continue;
    }
    buf += ch;
  }
  flush();

  return <span className={cn('text-[#AAAAAA] [text-shadow:0_1px_0_rgba(0,0,0,0.6)]', className)}>{out}</span>;
};
